function initAuthorSkills(root = document) {
    root.querySelectorAll('[data-js="author-skills"]').forEach((list) => {
        const step = Number(list.dataset.step) || 6;
        const moreBtn = list.querySelector('[data-js="author-skills-more"]');

        if (!moreBtn) {
            return;
        }

        const getHiddenItems = () =>
            [...list.querySelectorAll('.author-profile__skills-item--hidden')];

        const updateMoreButton = () => {
            if (!getHiddenItems().length) {
                moreBtn.remove();
            }
        };

        const showNext = () => {
            getHiddenItems()
                .slice(0, step)
                .forEach((item) => item.classList.remove('author-profile__skills-item--hidden'));

            updateMoreButton();
        };

        moreBtn.addEventListener('click', showNext);
        moreBtn.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                showNext();
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initAuthorSkills();
});
